<section class="filter-wrapper">
  <div class="keyword-wrapper">
    <input id="keyword" type="text" [formControl]="queryField" placeholder="Search for an address" autofocus>
  </div>
  <div *ngIf="!searchCriteria">
    <div class="resultSet" *ngFor="let suggestion of suggestions" (click)="selectResult(suggestion)">
      <span>{{ suggestion.text }}</span>
    </div>
  </div>
</section>